import { DateTime } from "luxon";

import { CallCenterCallReason } from "@/Common/Models/CallCenter/CallCenterCallReason";
import { MyleObjectType } from "@/Common/Models/Enum/MyleObjectType";
import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { PortalSyncStatus } from "@/Common/Models/Portal/Enums/PortalSyncStatus";
import { SharedItem } from "@/Common/Models/Portal/SharedItem/SharedItem";
import { SharedItemMessage } from "@/Common/Models/Portal/SharedItem/SharedItemMessage";
import { IPortalShareableItem } from "@/Common/Models/Portal/UI/IPortalShareableItem";

class PatientCommunicationsItem implements IPortalShareableItem {
    public Id: string;
    public FromEmployee: string;
    public CreationDate: DateTime;
    public FollowUpString: string;
    public FollowUpId: string;
    public Note: string;
    public SharedItem: SharedItem;
    public CallReasons: CallCenterCallReason[];
    public CallId: string;
    public ProviderId: string;
    public CallStart: string;
    public CallEnd: string | null;
    public IsCallOutgoing: boolean;
    constructor(fields?: Partial<PatientCommunicationsItem>) {
        (Object as any).assign(this, fields);
    }

    public getFormatedCreationDate(): string {
        return this.CreationDate.toFormat(`yyyy/LL/dd '${cacheStore.GetString("AtLabel")}' HH:mm:ss `);
    }

    public getMyleObjectType(): MyleObjectType {
        return MyleObjectType.CommunicationHistory;
    }

    public getGlobalPortalStatus(): PortalSyncStatus {
        if (this && this.SharedItem) {
            return this.SharedItem.Status;
        }
        return PortalSyncStatus.Unsent;
    }

    public getSharedItemId(): string {
        if (this && this.SharedItem)
            return this.SharedItem.SharedItemId;
        return null;
    }

    public getSharedItem(): SharedItem {
        return this.SharedItem;
    }

    public getSharedItemMessages(): SharedItemMessage[] {
        return null;
    }

    public getItemTypeHeader(): string {
        return ""; // A communication doesnt have an attachment at the moment
    }

    public getItemTitle(): string {
        return ""; // A communication doesnt have an attachment at the moment
    }

    public getDefaultSubject(): string {
        return ""; // A communication doesnt have a default subject at the moment
    }

    public getSharedItemPortalStatus(): PortalSyncStatus {
        return PortalSyncStatus.Unknown;
    }

    public getPortalObjectId(): string {
        return this.Id;
    }

    public getPortalLinkedItemType(): PortalLinkedItemType {
        return PortalLinkedItemType.CommunicationHistory;
    }

    public hasBeenModifiedSinceLastShared(): boolean {
        return false;
    }

    public hasBeenSharedOnPreviousEncounter(): boolean {
        return false;
    }
}

export { PatientCommunicationsItem };
